import * as actionTypes from '../actions/actionTypes';

const initialState = {
  businessUnit: {
    businessUnit: [],
    count: "",
    isLoading: false,
    isError: false
  },
  businessUnitDetails: [{}],
  deleteBunit: {},
  bunitFilterList: {},
  createbusinessUnitData: {},
  updatebusinessUnitData: {},
  isLoading: false,
  isError: false,
  countriesList:[]
}

const businessUnitReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_BUSINESS_UNIT_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_BUSINESS_UNIT_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, businessUnitDetails: { ...action.payload } };

    case actionTypes.FETCH_BUSINESS_UNIT_DETAILS_FAILURE:
      return { ...newState, isLoading: false, businessUnitDetails: { ...action.payload }, isError: true };

    case actionTypes.FETCH_BUSINESS_UNIT_LIST:
      return { ...newState, businessUnit: { ...newState.businessUnit, isLoading: true } };

    case actionTypes.FETCH_BUSINESS_UNIT_LIST_SUCCESS:
      return { ...newState, businessUnit: { businessUnit: [...action.payload.data], count: action.payload.totalCount, isLoading: false, isError: false } , createbusinessUnitData: {}, updatebusinessUnitData: {}, deleteBunit: {} };

    case actionTypes.FETCH_BUSINESS_UNIT_LIST_FAILURE:
      return { ...newState, businessUnit: {businessUnit:{...action.payload}, count: action.payload.totalCount, isLoading: false, isError: true } };

    case actionTypes.FETCH_BUNIT_FILTER_LIST:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_BUNIT_FILTER_LIST_SUCCESS:
      return { ...newState, isLoading: false, bunitFilterList: { ...action.payload } };

    case actionTypes.FETCH_BUNIT_FILTER_LIST_FAILURE:
      return { ...newState, isLoading: false, isError: true, bunitFilterList: { ...action.payload } };

      case actionTypes.CREATE_BUNIT:
      return { ...newState, isLoading: true };

    case actionTypes.CREATE_BUNIT_SUCCESS:
      return { ...newState, isLoading: false, createbusinessUnitData: { ...action.payload } };

    case actionTypes.CREATE_BUNIT_FAILURE:
      return { ...newState, isLoading: false, isError: true, createbusinessUnitData: { ...action.payload } };

    case actionTypes.UPDATE_BUNIT:
    return { ...newState, isLoading: true };

    case actionTypes.UPDATE_BUNIT_SUCCESS:
      return { ...newState, isLoading: false, updatebusinessUnitData: { ...action.payload } };

    case actionTypes.UPDATE_BUNIT_FAILURE:
      return { ...newState, isLoading: false, isError: true, updatebusinessUnitData: { ...action.payload } };

    case actionTypes.RESET_BUNIT:
      return { ...newState, isLoading: false, businessUnit: {
        businessUnit: [],
        count: "",
        isLoading: false,
        isError: false
      }, };

    case actionTypes.DELETE_BUNIT:
        return {...newState , isLoading: true, deleteBunit:{}};
          
    case actionTypes.DELETE_BUNIT_SUCCESS:
        return {...newState , isLoading: false, isError:false, deleteBunit:{...action.payload}, errorMessage: {}};
  
    case actionTypes.DELETE_BUNIT_FAILURE:
        return {...newState , isLoading: false, isError:true, errorMessage: {...action.payload}, deleteUser: {} };

    case actionTypes.FETCH_COUNTRIES_LIST_SUCCESS:
      return {...newState , isLoading: false, isError:false, countriesList:{...action.payload}};

  case actionTypes.FETCH_COUNTRIES_LIST_FAILURE:
      return {...newState , isLoading: false, isError:true, countriesList:{...action.payload} };
    default:
      return { ...newState };
  }
};


export default businessUnitReducer;